/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * OAuth API
 * OAuth API for authentication and authorization
 * OpenAPI spec version: 1.0.0
 */

import type {
	MutationFunction,
	QueryClient,
	UseMutationOptions,
	UseMutationResult,
} from "@tanstack/react-query"
import { useMutation } from "@tanstack/react-query"
import type { BodyType, ErrorType } from "../../custom-oauth-client"

import { customFetch } from "../../custom-oauth-client"
import type {
	ExchangeAuthCode200,
	ExchangeAuthCode400,
	ExchangeAuthCode401,
	ExchangeAuthCode500,
	ExchangeAuthCodeBody,
	RefreshTokens200,
	RefreshTokens400,
	RefreshTokens403,
	RefreshTokens500,
	RefreshTokensBody,
} from "../types/oauth"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Обменивает код авторизации, полученный от OAuth провайдера,
на JWT токен доступа к Stats API.

 * @summary Обмен кода авторизации на токен доступа
 */
export type exchangeAuthCodeResponse200 = {
	data: ExchangeAuthCode200
	status: 200
}

export type exchangeAuthCodeResponse400 = {
	data: ExchangeAuthCode400
	status: 400
}

export type exchangeAuthCodeResponse401 = {
	data: ExchangeAuthCode401
	status: 401
}

export type exchangeAuthCodeResponse500 = {
	data: ExchangeAuthCode500
	status: 500
}

export type exchangeAuthCodeResponseSuccess = exchangeAuthCodeResponse200 & {
	headers: Headers
}
export type exchangeAuthCodeResponseError = (
	| exchangeAuthCodeResponse400
	| exchangeAuthCodeResponse401
	| exchangeAuthCodeResponse500
) & {
	headers: Headers
}

export type exchangeAuthCodeResponse =
	| exchangeAuthCodeResponseSuccess
	| exchangeAuthCodeResponseError

export const getExchangeAuthCodeUrl = () => {
	return `/exchange`
}

export const exchangeAuthCode = async (
	exchangeAuthCodeBody: ExchangeAuthCodeBody,
	options?: RequestInit,
): Promise<exchangeAuthCodeResponse> => {
	return customFetch<exchangeAuthCodeResponse>(getExchangeAuthCodeUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(exchangeAuthCodeBody),
	})
}

export const getExchangeAuthCodeMutationOptions = <
	TError = ErrorType<
		ExchangeAuthCode400 | ExchangeAuthCode401 | ExchangeAuthCode500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof exchangeAuthCode>>,
		TError,
		{ data: BodyType<ExchangeAuthCodeBody> },
		TContext
	>
	request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
	Awaited<ReturnType<typeof exchangeAuthCode>>,
	TError,
	{ data: BodyType<ExchangeAuthCodeBody> },
	TContext
> => {
	const mutationKey = ["exchangeAuthCode"]
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof exchangeAuthCode>>,
		{ data: BodyType<ExchangeAuthCodeBody> }
	> = (props) => {
		const { data } = props ?? {}

		return exchangeAuthCode(data, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type ExchangeAuthCodeMutationResult = NonNullable<
	Awaited<ReturnType<typeof exchangeAuthCode>>
>
export type ExchangeAuthCodeMutationBody = BodyType<ExchangeAuthCodeBody>
export type ExchangeAuthCodeMutationError = ErrorType<
	ExchangeAuthCode400 | ExchangeAuthCode401 | ExchangeAuthCode500
>

/**
 * @summary Обмен кода авторизации на токен доступа
 */
export const useExchangeAuthCode = <
	TError = ErrorType<
		ExchangeAuthCode400 | ExchangeAuthCode401 | ExchangeAuthCode500
	>,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof exchangeAuthCode>>,
			TError,
			{ data: BodyType<ExchangeAuthCodeBody> },
			TContext
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof exchangeAuthCode>>,
	TError,
	{ data: BodyType<ExchangeAuthCodeBody> },
	TContext
> => {
	return useMutation(getExchangeAuthCodeMutationOptions(options), queryClient)
}

/**
 * Обменивает действующий refresh token на новую пару access_token и refresh_token.
Предыдущие токены становятся недействительными.

 * @summary Обновление пары токенов доступа
 */
export type refreshTokensResponse200 = {
	data: RefreshTokens200
	status: 200
}

export type refreshTokensResponse400 = {
	data: RefreshTokens400
	status: 400
}

export type refreshTokensResponse403 = {
	data: RefreshTokens403
	status: 403
}

export type refreshTokensResponse404 = {
	data: void
	status: 404
}

export type refreshTokensResponse500 = {
	data: RefreshTokens500
	status: 500
}

export type refreshTokensResponseSuccess = refreshTokensResponse200 & {
	headers: Headers
}
export type refreshTokensResponseError = (
	| refreshTokensResponse400
	| refreshTokensResponse403
	| refreshTokensResponse404
	| refreshTokensResponse500
) & {
	headers: Headers
}

export type refreshTokensResponse =
	| refreshTokensResponseSuccess
	| refreshTokensResponseError

export const getRefreshTokensUrl = () => {
	return `/refresh`
}

export const refreshTokens = async (
	refreshTokensBody: RefreshTokensBody,
	options?: RequestInit,
): Promise<refreshTokensResponse> => {
	return customFetch<refreshTokensResponse>(getRefreshTokensUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(refreshTokensBody),
	})
}

export const getRefreshTokensMutationOptions = <
	TError = ErrorType<
		RefreshTokens400 | RefreshTokens403 | void | RefreshTokens500
	>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof refreshTokens>>,
		TError,
		{ data: BodyType<RefreshTokensBody> },
		TContext
	>
	request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
	Awaited<ReturnType<typeof refreshTokens>>,
	TError,
	{ data: BodyType<RefreshTokensBody> },
	TContext
> => {
	const mutationKey = ["refreshTokens"]
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof refreshTokens>>,
		{ data: BodyType<RefreshTokensBody> }
	> = (props) => {
		const { data } = props ?? {}

		return refreshTokens(data, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type RefreshTokensMutationResult = NonNullable<
	Awaited<ReturnType<typeof refreshTokens>>
>
export type RefreshTokensMutationBody = BodyType<RefreshTokensBody>
export type RefreshTokensMutationError = ErrorType<
	RefreshTokens400 | RefreshTokens403 | void | RefreshTokens500
>

/**
 * @summary Обновление пары токенов доступа
 */
export const useRefreshTokens = <
	TError = ErrorType<
		RefreshTokens400 | RefreshTokens403 | void | RefreshTokens500
	>,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof refreshTokens>>,
			TError,
			{ data: BodyType<RefreshTokensBody> },
			TContext
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof refreshTokens>>,
	TError,
	{ data: BodyType<RefreshTokensBody> },
	TContext
> => {
	return useMutation(getRefreshTokensMutationOptions(options), queryClient)
}
